var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.69 1.49s.02-.02 0 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35 10.84a14.21 14.21 0 0 1 4 2c-.61 1.07-1.57 3.66-1.7 4s-.26.47-.48.95c-.06.34.58.54.67.3 1.42-2.44 1.58-2.86 2.54-4.66.93.53 1 .77 5.87 2.3.35.06.55-.18 0-.71-.42-.17-2.73-1.29-5.32-2.62 1.08-2.47 1.57-3 1.75-3.61.32-.34-.14-1-.94.16C11.51 9.19 11 10 11 10a13.75 13.75 0 0 0-1.12 1.78 15.63 15.63 0 0 0-2.82-1.31A6.58 6.58 0 0 0 4.77 10c-.39.11-.63.34-.06.68Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.73 7.64c-.26-.31-.53.55-.4 1 .13.57 0 .64-.26 1.21a24.31 24.31 0 0 1-1.67 3.68c-1.57 2.41-2.41 4.32-3.78 6.76a5.33 5.33 0 0 1-3 2.56 5.91 5.91 0 0 1-3-.52c-1-.39-2.17-.62-3-1a25.38 25.38 0 0 0-2.73-1.23c-.92-.31-2.48-1-2.69-2-.05-.2-.66-.58-.66.13 0 1.75 3.17 2.62 4.08 3a23.62 23.62 0 0 0 2.45 1.19c.69.26 1.42.45 2.1.75 2.7 1.2 4.21.78 5.53-.24 1.88-1.43 2.19-2.91 4.37-7.06a34.54 34.54 0 0 0 1.86-3.55c.86-1.94 1.69-3.55.8-4.68Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1 18.34a26.15 26.15 0 0 1 2.52 1.17c1 .53 2.08.7 3.07 1.13 6.68 2.86 7.06-3.57 10.91-9.84a12.09 12.09 0 0 0 1.73-4.4c-.07-1.48-1.24-2.2-2.47-3A23.37 23.37 0 0 0 14.15.75 32 32 0 0 0 10.3 0c-.08 0-.23.41.24.6 1.27.5 1.42.19 3.37.86a21.7 21.7 0 0 1 6.78 3.64 2 2 0 0 1 .5 2.47 14.14 14.14 0 0 1-1.4 2.59l-1.92-.86c-.53-.26-1.6-1.09-3.45-2.06-4.8-2.54-5.9-2.35-6.67-2.62C8.93 3 9.43 1.77 9.69 1.49a.31.31 0 0 0-.23-.34C8.89 1 8.42 2.39 8.2 2.76c-.93 1.59-2.36 3-3.39 4.56C1.87 11.8 0 14.71 1.31 16.5a6.15 6.15 0 0 0 2.79 1.84Zm-.49-7.52c.22-.4 2.23-3.7 3.75-5.69a23.07 23.07 0 0 1 4.31 2c.28.14 4.45 2.23 5.16 2.64a20.33 20.33 0 0 0 2.2.86 2.61 2.61 0 0 0 .35.18c-.32.53-.63 1.07-.92 1.62-1.05 2-2.34 5.78-4.52 7.26a4.37 4.37 0 0 1-3.94 0c-1-.43-4.66-2.07-5.53-2.37s-2.39-1-2.57-1.87c-.26-1.22 1.1-3.53 1.71-4.63Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.63 7.7c.1.09.25.07.46-.09a3.13 3.13 0 0 0 1.2-1.8.3.3 0 1 0-.45-.4c-1.43.87-1.58 1.96-1.21 2.29Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.47a6.31 6.31 0 0 0 1.33.41.34.34 0 0 0 .49-.48c-.64-1-2.47-1.3-2.74-1a.3.3 0 0 0-.1.42A8.26 8.26 0 0 0 8 8.47Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.56c0 .3-.09.11 1 .9a5.28 5.28 0 0 1-.32.77.34.34 0 0 0 .49.48 3.37 3.37 0 0 0 .78-.75c.06-.06 0-.07.14 0a5.44 5.44 0 0 0 .79.28c.22 0 .29-.13.34-.21.19-.3-.51-.82-.8-1 .06-.27.1-.53.14-.75A.3.3 0 1 0 15 10c-.13.16-.31.34-.48.55a5.66 5.66 0 0 0-1.13-.23c-.28 0-.39.11-.39.24Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18 14.72a2.19 2.19 0 0 1 .64-.25c1.13 1.25.89 1.18 1.12 1.18a.35.35 0 0 0 .35-.35 2.66 2.66 0 0 0-.42-1.24c.62-.37.84-.25 1.1-.49a.3.3 0 0 0 0-.42.65.65 0 0 0-.47-.27 2.73 2.73 0 0 0-1.2.2c-.27-.49-.33-.63-.42-.69a.43.43 0 0 0-.25-.13c-.11 0-.25 0-.34.13s-.14.13.08 1.19c-.39.28-1 .8-.7 1.14a.36.36 0 0 0 .51 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 16.32c.51.42 1.13.36 1.55.64a.34.34 0 1 0 .49-.47 2.23 2.23 0 0 0-1.41-1.06c-.11 0-1-.18-1.11-.15s-.3.16-.26.31c0 .3.66.67.74.73Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76 17.86a3.43 3.43 0 0 0 1 .53c.55.19 1.66.4 1.66-.17a5 5 0 0 0-3.24-1.37c-.1 0-1.18.24.58 1.01Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountancy);
export default __webpack_public_path__ + "static/media/accountancy.d6d68da69af6f3264f5699d6a9e17fb4.svg";
export { ForwardRef as ReactComponent };